import { CrmFieldData } from "../../AppDataProvider/types";
import { CrmFieldInput } from "../../GeneratedGraphQL";

export const getCrmFieldBookingInput = (
  crmFieldData?: CrmFieldData | null,
): CrmFieldInput[] => {
  return crmFieldData
    ? Object.entries(crmFieldData).map(([id, value]) => ({
        id,
        value: value ?? "",
      }))
    : [];
};
